import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { isOrgEligibleForDspAdvertiserRequest } from "@front/m19-models";
import { AccountSelectionService, OrganizationService } from "@front/m19-services";
import { DspAdvertiserRequestService } from "libs/m19-services/src/lib/m19-services/dspAdvertiserRequest.service";
import { combineLatest, map, switchMap } from "rxjs";

export const canRequestAdvertiserGuard: CanActivateFn = (_) => {
  const accountSelectionService = inject(AccountSelectionService);
  const dspAdvertiserRequestService = inject(DspAdvertiserRequestService);
  const organizationService = inject(OrganizationService);
  const router = inject(Router);

  return accountSelectionService.singleAccountMarketplaceSelection$.pipe(
    switchMap((accountMarketplace) =>
      combineLatest([
        dspAdvertiserRequestService.dspAdvertiserRequest$,
        organizationService.find(accountMarketplace.resourceOrganizationId!),
      ]).pipe(
        map(([dspAdvertiserRequest, organization]) => {
          const hasNoAdvertiser = dspAdvertiserRequest || !accountMarketplace.dspAdvertiserId;

          if (hasNoAdvertiser && isOrgEligibleForDspAdvertiserRequest(organization)) {
            return true;
          }
          return router.createUrlTree(["/dashboard"]);
        }),
      ),
    ),
  );
};
